export const heroData = {
  title: "专业文件起草与官网建设一站式服务",
  subtitle: "17.c 起草官网，为企业提供高效、规范的文件起草解决方案，助力企业快速搭建权威官方网站，提升品牌公信力与线上影响力",
  ctaText: "立即了解详情",
  ctaLink: "/category/wenjian-qicao",
  secondaryText: "查看服务方案",
  secondaryLink: "/category/guanwang-jianshe",
};

export const statsData = [
  { value: "5000+", label: "服务企业客户" },
  { value: "98%", label: "客户满意度" },
  { value: "10年+", label: "行业经验" },
  { value: "20000+", label: "起草文件数" },
];

export const serviceData = [
  {
    id: "wenjian-qicao",
    icon: "ri-file-text-line",
    title: "文件起草服务",
    description: "专业团队为您起草各类规范文件，涵盖商业合同、法律文书、企业章程、合作协议等，确保文件合法合规、条理清晰、逻辑严谨。",
    features: ["商业合同起草", "法律文书撰写", "公司章程制定", "合作协议拟定"],
    imageQuery: "Professional document drafting service on a warm wooden desk with elegant stationery and a fountain pen, soft natural lighting, sophisticated office setting, warm cream tones, editorial photography style with clean composition and refined aesthetic",
  },
  {
    id: "guanwang-jianshe",
    icon: "ri-global-line",
    title: "官网建设服务",
    description: "从域名注册到网站上线，提供全流程官方网站搭建服务。响应式设计、SEO优化、品牌形象塑造，让您的企业在线形象专业出众。",
    features: ["企业官网搭建", "响应式网站设计", "SEO搜索引擎优化", "品牌形象塑造"],
    imageQuery: "Modern website design workspace with elegant UI sketches on a large screen, minimalist office with warm ambient lighting, creative web development atmosphere, sleek design tools arranged on desk, professional branding mood board on wall, warm cream and wood tones",
  },
  {
    id: "falv-wenshu",
    icon: "ri-scales-3-line",
    title: "法律文书服务",
    description: "资深法律顾问为您审核和起草各类法律文书，确保文件的严谨性和法律效力，为您的商业活动提供坚实的法律保障。",
    features: ["合同审查修订", "诉讼文书起草", "法律意见书", "合规文件准备"],
    imageQuery: "Legal document review on a professional mahogany desk with leather-bound law books in background, elegant brass desk lamp casting warm light, sophisticated legal office atmosphere, gavel and scales of justice, warm amber tones, refined editorial style",
  },
  {
    id: "shangye-hetong",
    icon: "ri-briefcase-line",
    title: "商业合同服务",
    description: "针对不同行业和业务场景，定制化起草商业合同，包括采购合同、销售合同、合作协议、保密协议等，保障您的商业利益。",
    features: ["采购销售合同", "战略合作协议", "保密协议起草", "合同风险评估"],
    imageQuery: "Business contract signing moment captured in warm natural light, elegant wooden conference table with premium documents, two hands exchanging signed papers, sophisticated corporate setting with soft background, warm cream and gold tones, professional editorial photography",
  },
];

export const featureData = [
  {
    icon: "ri-speed-up-line",
    title: "高效快捷",
    description: "标准化流程确保高效交付，紧急需求最快24小时内完成起草，让您的业务推进不延误。",
  },
  {
    icon: "ri-shield-check-line",
    title: "规范合规",
    description: "所有文件严格遵循法律法规和行业标准，由资深专家把关审核，确保每份文件的规范性和合规性。",
  },
  {
    icon: "ri-team-line",
    title: "专业团队",
    description: "汇聚法律、商务、技术等多领域专家，为您提供全方位的专业文件起草与官网建设服务。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "价格透明",
    description: "明码标价，无隐形消费。多种服务套餐可选，满足不同规模和预算的企业需求。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "全程跟踪",
    description: "专属顾问一对一服务，从需求沟通到文件交付全程跟踪，确保服务质量与客户满意度。",
  },
  {
    icon: "ri-lock-line",
    title: "信息安全",
    description: "严格的信息保密制度，签署保密协议，确保您的商业信息和文件内容安全无忧。",
  },
];

export const caseData = [
  {
    id: "case-1",
    title: "某科技公司全套商业合同体系搭建",
    description: "为一家快速成长的科技企业起草了包括采购合同、销售合同、保密协议、员工竞业协议等在内的全套商业合同体系，帮助其规范商业运营。",
    category: "商业合同",
    stat: "合同数量：30+份",
  },
  {
    id: "case-2",
    title: "某制造企业官方网站从零搭建",
    description: "为一家传统制造企业完成了从域名注册、网站设计到上线运营的全流程官网建设，显著提升了企业的线上形象和客户获取能力。",
    category: "官网建设",
    stat: "网站流量提升：300%",
  },
  {
    id: "case-3",
    title: "某连锁品牌加盟体系法律文书起草",
    description: "为一家快速扩张的连锁品牌起草了完整的加盟体系法律文书，包括加盟合同、品牌授权协议、运营规范等，保障品牌方与加盟商双方的合法权益。",
    category: "法律文书",
    stat: "加盟门店：200+家",
  },
];

export const testimonialData = [
  {
    id: "t-1",
    name: "张伟",
    position: "某科技公司CEO",
    content: "17.c起草官网的服务效率远超预期。我们公司的全套商业合同体系仅用了两周就完成了起草和审核，每份文件都非常专业规范。强烈推荐给每一位创业者。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businessman%20headshot%20in%20formal%20attire%20with%20warm%20natural%20lighting%20and%20soft%20background&width=80&height=80&seq=avatar-zhang&orientation=squarish",
  },
  {
    id: "t-2",
    name: "李娜",
    position: "某制造企业市场总监",
    content: "从域名到上线，17.c帮我们搭建的官网专业又美观。上线后客户主动咨询量比之前翻了三倍，效果立竿见影。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20businesswoman%20headshot%20in%20elegant%20attire%20with%20warm%20natural%20lighting%20and%20soft%20background&width=80&height=80&seq=avatar-li&orientation=squarish",
  },
  {
    id: "t-3",
    name: "王磊",
    position: "某连锁品牌创始人",
    content: "加盟体系的整套法律文书都是17.c起草的，内容严谨完善，法务顾问审核一次通过。帮我们节省了大量时间和精力。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20Chinese%20entrepreneur%20headshot%20in%20business%20casual%20attire%20with%20warm%20natural%20lighting%20and%20soft%20background&width=80&height=80&seq=avatar-wang&orientation=squarish",
  },
];

export const faqData = [
  {
    question: "文件起草服务的流程是怎样的？",
    answer: "服务流程分为四步：第一步，需求沟通——您提交文件需求，我们的顾问与您详细沟通；第二步，方案制定——专业团队制定起草方案和报价；第三步，文件起草——资深专家完成文件起草；第四步，审核交付——法律顾问审核后交付给您，并根据您的反馈进行修改完善。",
  },
  {
    question: "官网建设需要多长时间？",
    answer: "根据网站的复杂程度，标准企业官网通常在7-15个工作日内完成。简单的展示型网站约7个工作日，包含较多功能和页面的综合型网站约15个工作日。我们会根据您的具体需求给出准确的时间预估。",
  },
  {
    question: "文件起草的收费标准是什么？",
    answer: "我们采用透明的阶梯定价模式。简单的标准文件（如保密协议）起价500元，复杂文件（如全套商业合同体系）根据工作量和复杂度进行报价。所有报价均在起草前明确告知，无任何隐形费用。",
  },
  {
    question: "起草的文件是否具有法律效力？",
    answer: "是的。我们的文件起草团队包含持证法律顾问，所有法律相关文件均经过法律专业人士审核，确保符合现行法律法规，具备完整的法律效力。如有特殊需求，还可安排盖章见证服务。",
  },
  {
    question: "官网建设后是否提供维护服务？",
    answer: "提供完善的技术支持和维护服务。包括定期的安全更新、内容修改、性能优化等。我们还提供不同级别的维护套餐，您可以根据实际需求选择，确保网站长期稳定运行。",
  },
  {
    question: "如果对起草的文件不满意怎么办？",
    answer: "我们承诺无限次修改直到您满意为止。在文件交付后30天内，您可以提出修改意见，我们将免费为您进行调整和完善。客户满意度是我们最看重的指标。",
  },
];

export const contactData = {
  phone: "400-123-4567",
  email: "contact@17.c",
  address: "北京市朝阳区建国路88号SOHO现代城A座",
  wechat: "qicao17c",
  workHours: "周一至周五 9:00 - 18:00",
};